import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Play, X, Check } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const DemoModal = ({ isOpen, onClose }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleLaunchDemo = () => {
    onClose();
    navigate('/demo');
  };

  if (!isOpen) return null;

  const features = t('demoModal.features') || [
    'Interactive Dashboard Tour',
    'Feature Demonstrations',
    'Real Use Case Examples',
    'Q&A Session'
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-md">
      <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl border border-slate-200 overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        <div className="relative bg-slate-800 px-6 py-8 text-white">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 rounded-lg text-slate-300 hover:text-white hover:bg-white/10 transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5" strokeWidth={1.75} />
          </button>
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-xl bg-white/10 flex items-center justify-center shrink-0">
              <Play className="w-7 h-7 text-white" strokeWidth={2} fill="currentColor" />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-white tracking-tight">{t('demoModal.title')}</h2>
              <p className="text-sm text-slate-300 mt-0.5">{t('demoModal.subtitle')}</p>
            </div>
          </div>
          {Array.isArray(features) && features.length > 0 && (
            <ul className="mt-6 space-y-2">
              {features.map((item, i) => (
                <li key={i} className="flex items-center gap-2 text-sm text-slate-200">
                  <Check className="w-4 h-4 text-emerald-400 shrink-0" strokeWidth={2} />
                  {item}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="p-6 space-y-5">
          <p className="text-sm text-slate-600 leading-relaxed">
            {t('demoModal.description')}
          </p>

          <button
            onClick={handleLaunchDemo}
            className="w-full flex items-center justify-center gap-2 px-5 py-3.5 bg-slate-800 text-white text-sm font-semibold rounded-xl hover:bg-slate-700 transition-colors shadow-sm"
          >
            <Play className="w-5 h-5" strokeWidth={2} fill="currentColor" />
            {t('demoModal.launchDemo')}
          </button>
        </div>

        <div className="px-6 pb-6">
          <button
            onClick={onClose}
            className="w-full py-2.5 text-sm font-medium text-slate-500 hover:text-slate-800 transition-colors"
          >
            {t('demoModal.close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DemoModal;
